import name from './name';
const NAME = name.toUpperCase();
export const ADD_ERROR = `${NAME}/ADD_ERROR`;
export const REMOVE_ERROR = `${NAME}/REMOVE_ERROR`;
export const ADD_TOAST = `${NAME}/ADD_TOAST`;
export const REMOVE_TOAST = `${NAME}/REMOVE_TOAST`;
export const RESET = `${NAME}/RESET`;
export const SET_LOCALE = `${NAME}/SET_LOCALE`;
export const OPEN_MODAL = `${NAME}/OPEN_MODAL`;
export const CLOSE_MODAL = `${NAME}/CLOSE_MODAL`;
